module.exports = __webpack_public_path__ + "img/样例产品.ed427897.jpg";